module.exports = __webpack_public_path__ + "img/Vector 14.5094dca0.png";